import { CharacterData } from "../../../../utils/game/character/CharacterData";
import FlexColumn from "../../../../common/components/layout/Flexbox/FlexColumn";
import FlexRow from "../../../../common/components/layout/Flexbox/FlexRow";

import "./CharacterHeader_style.css";
import { ReactNode } from "react";

type Props = {
    characterData: CharacterData;
    endContent?: ReactNode | null;
};

export default function CharacterHeader({
    characterData,
    endContent,
}: Props): JSX.Element {
    return (
        <FlexRow className="character-sheet-header">
            <h2>{characterData.name}</h2>
            <h3>{`${characterData.gender}${
                characterData.race
                    ? ` ${characterData.race.name}`
                    : ` ${characterData.raceText}`
            } - Level ${characterData.level}`}</h3>
            <div className="end-content">{endContent}</div>
        </FlexRow>
    );
}
